"use client";

import { useMotionMode } from "@/context/MotionContext";

/**
 * Hook that returns whether animations should run.
 *
 * Checks are performed in MotionContext:
 * - prefers-reduced-motion media query
 * - GPU tier detection (via detect-gpu)
 * - User's motion mode toggle
 *
 * canAnimate = !reducedMotion && gpuTier >= 2 && mode === "on"
 *
 * Returns false until MotionContext is mounted to prevent race conditions.
 *
 * DEV: Force low-performance mode via URL param ?lowperf=1
 */
export function useCanAnimate(): boolean {
  const { canAnimate } = useMotionMode();

  // DEV: Force low-performance mode via URL param
  if (typeof window !== "undefined" && process.env.NODE_ENV === "development") {
    const params = new URLSearchParams(window.location.search);
    if (params.get("lowperf") === "1") {
      return false;
    }
  }

  return canAnimate;
}
